// extracted by mini-css-extract-plugin
export default {"quickView":"product_quickView__UOxTj","container":"product_container__+X94J"};